import { IAppState } from "../../../app/appTypes"
import { IAuditEvent } from "../../../features/audit/state/auditEventTypes"

export const getAuditEventIdsByEntityId = (state: IAppState, entityId: string): string[] => {
  return state.entities.auditEvents.allIdsByEntityId[entityId] || []
}

export const getAuditEventById = (state: IAppState, id: string): IAuditEvent =>
  state.entities.auditEvents.byId[id]
